module.exports = __webpack_public_path__ + "static/media/Less-than-Container-Load.d33c957e.jpg";